/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Not_ConfiguredInputs */

const en_landing_studio_not_configured = /** @type {(inputs: Landing_Studio_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generation isn't configured yet. Please try again later.`)
};

const zh_landing_studio_not_configured = /** @type {(inputs: Landing_Studio_Not_ConfiguredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成服务尚未配置，请稍后再试。`)
};

/**
* | output |
* | --- |
* | "Generation isn't configured yet. Please try again later." |
*
* @param {Landing_Studio_Not_ConfiguredInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_not_configured = /** @type {((inputs?: Landing_Studio_Not_ConfiguredInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Not_ConfiguredInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_not_configured(inputs)
	return zh_landing_studio_not_configured(inputs)
});
export { landing_studio_not_configured as "landing.studio.not_configured" }